import ClearIcon from "@mui/icons-material/Clear";
import { FormControl } from "@mui/material";
import { AnimatePresence } from "framer-motion";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import CloseIcon from "../../../../components/CloseIcon/CloseIcon";
import CustomButtonV2 from "../../../../components/CustomButtonV2/CustomButtonV2.js";
import HeaderCadastro from "../../../../components/HeaderCadastro/HeaderCadastro";
import ModalConfirmacao from "../../../../components/ModalConfirmacao/ModalConfirmacao.tsx";
import ModalUsuario from "../../../../components/ModalUsuario/ModalUsuario.tsx";
import TabelaV2 from "../../../../components/TabelaV2/TabelaV2";
import ToastErro from "../../../../components/Toast/ToastErro/ToastErro.tsx";
import ToastSucesso from "../../../../components/Toast/ToastSucesso/ToastSucesso.tsx";
import { useProfile } from "../../../../contexts/ProfileContext.tsx";
import RequestControllerRedux from "../../../../contexts/RequestController";
import TabelaRedux from "../../../../contexts/Tabela";
import MotionContainer from "../../../../core/components/MotionContainer.tsx";
import MotionSemAutorizacao from "../../../../core/components/MotionSemAutorizacao.tsx";
import Separator from "../../../../core/components/Separator.tsx";
import Layout from "../../../../core/layout/Layout.tsx";
import {
	emailValido,
	telefoneValido,
} from "../../../../core/utils/validators.ts";
import { telefoneMask } from "../../../../regex/telefoneMask";
import {
	cadastraFilial,
	deleteFilialPorId,
	editaFilialPorId,
	getFilial,
	getFilialPorId,
} from "../../../../services/ModuloGerenciador/Filial";
import { getFilialDependencias } from "../../../../services/ModuloGerenciador/Geral.ts";
import "./Filial.css";

function Filial(props) {
	const { profile, hasRegra, tabelaEmpresa } = useProfile();

	const { setDadosRequestControllerRedux } = useContext(RequestControllerRedux);

	const [dadosTabela, setDadosTabela] = useState([]);

	const [telaCadastro, setTelaCadastro] = useState(false);

	const [editando, setEditando] = useState(false);

	const [loading, setLoading] = useState(false);

	const [values, setValues] = useState({});

	const [validator, setValidator] = useState([]);

	const [listaCidades, setListaCidades] = useState([]);

	const { tabelaRedux, setTabelaRedux } = useContext(TabelaRedux);

	const navigate = useNavigate();

	const [openUsuario, setOpenUsuario] = useState(false);

	const [open, setOpen] = useState(false);

	const [textoSucesso, setTextoSucesso] = useState("");

	const [textoErro, setTextoErro] = useState("");

	const [nomeValido, setNomeValido] = useState(true);

	const [cidadeValido, setCidadeValido] = useState(true);

	const [responsavelValido, setResponsavelValido] = useState(true);

	const [locValido, setLocValido] = useState(true);

	const handleClose = (value) => {
		setOpen(false);
	};

	const [openToastSucesso, setOpenToastSucesso] = useState(false);

	const handleCloseToastSucesso = (value) => {
		setOpenToastSucesso(false);
	};

	const [openToastErro, setOpenToastErro] = useState(false);

	const handleCloseToastErro = (value) => {
		setOpenToastErro(false);
	};

	const handleCloseUsuario = (value) => {
		setOpenUsuario(false);
	};

	const buscarDependencias = async () => {
		setLoading(true);
		await getFilialDependencias(profile?.token)
			.then((result) => {
				setListaCidades(result.data.cidadeEstados);
				setDadosTabela(result.data.filials);
				setTabelaRedux({});
				setTimeout(() => {
					setLoading(false);
				}, 3000);
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	const buscarFilial = async () => {
		setLoading(true);
		await getFilial(profile?.token).then((result) => {
			setDadosTabela(result.data);
			setTabelaRedux({});
			setLoading(false);
		});
	};

	const preencherDadosEditando = async (result) => {
		const cidadeSelecionado = listaCidades.find(
			(option) => option.idCidadeEstado === result.data.cidadeEstadoId
		);
		if (cidadeSelecionado) {
			setValuesSelect((current) => ({
				...current,
				cidadeEstadoId: cidadeSelecionado,
			}));
		}
	};

	const buscarFilialPorID = async () => {
		await getFilialPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					if (editando) {
						await preencherDadosEditando(result);
						setValues(result.data);
					}
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				}
			});
	};

	const buscarFilialPorIDModal = async (id) => {
		await getFilialPorId(id, profile?.token)
			.then(async (result) => {
				if (result.status === 200) {
					await preencherDadosEditando(result);
					setValues(result.data);
				}
			})
			.catch((error) => {
				if (!editando) {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
				}
			});
	};

	const cadastrar = async () => {
		setOpenToastErro(false);
		if (!telefoneValido(values.telefone)) {
			setValidator((current) => ({ ...current, telefone: "false" }));
			setOpenToastErro(true);
			setTextoErro("Telefone inválido");
			return;
		}

		if (!emailValido(values.email)) {
			setValidator((current) => ({ ...current, email: "false" }));
			setOpenToastErro(true);
			setTextoErro("Email inválido");
			return;
		}

		if (
			values.nome &&
			values.cidadeEstadoId &&
			values.responsavel &&
			values.complementoLocalizacao &&
			validator.nome === "true" &&
			validator.cidadeEstadoId === "true" &&
			validator.responsavel === "true" &&
			validator.telefone === "true" &&
			validator.cidadeEstadoId === "true"
		) {
			setLoading(true);
			await cadastraFilial(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarFilial();
						setDadosRequestControllerRedux("Fechar Modal Filial");
						setTabelaRedux({});
						setTextoSucesso("Cadastrado Com Sucesso");
						setOpenToastSucesso(true);
						setTelaCadastro(false);
						setValues({});
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
					}
					setOpenToastErro(true);
					setLoading(false);
				});
		} else {
			setNomeValido(false);
			setLocValido(false);
			setCidadeValido(false);
			setResponsavelValido(false);
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
		}
		setLoading(false);
	};

	const editar = async () => {
		setOpenToastErro(false);
		if (!telefoneValido(values.telefone)) {
			setValidator((current) => ({ ...current, telefone: "false" }));
			setOpenToastErro(true);
			setTextoErro("Telefone inválido");
			return;
		}

		if (!emailValido(values.email)) {
			setValidator((current) => ({ ...current, email: "false" }));
			setOpenToastErro(true);
			setTextoErro("Email inválido");
			return;
		}

		if (
			values.nome !== "" &&
			values.cidadeEstadoId !== "" &&
			values.responsavel !== "" &&
			values.email !== "" &&
			values.complementoLocalizacao !== ""
		) {
			setLoading(true);
			await editaFilialPorId(values, profile?.token)
				.then((result) => {
					if (result.status === 200) {
						buscarFilial();
						setTabelaRedux({});
						setTextoSucesso("Editado Com Sucesso");
						setOpenToastSucesso(true);
						setTelaCadastro(false);
						setValues({});
						setValuesSelect({});
						setEditando(false);
					}
				})
				.catch((error) => {
					if (typeof error.response.data === "string") {
						setTextoErro(error.response.data);
						setOpenToastErro(true);
						setLoading(false);
					} else {
						setTextoErro(
							"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
						);
						setOpenToastErro(true);
						setLoading(false);
					}
					setLoading(false);
				});
		} else {
			setTextoErro("Há campos sem preencher!");
			setOpenToastErro(true);
		}
		setLoading(false);
	};

	const deletarFilial = async () => {
		setLoading(true);
		await deleteFilialPorId(tabelaRedux.colunaSelecionada, profile?.token)
			.then((result) => {
				if (result.status === 200) {
					buscarFilial();
					setTabelaRedux({});
					setTextoSucesso("Deletado Com Sucesso");
					setOpenToastSucesso(true);
				}
			})
			.catch((error) => {
				if (typeof error.response.data === "string") {
					setTextoErro(error.response.data);
					setOpenToastErro(true);
					setLoading(false);
				} else {
					setTextoErro(
						"Ocorreu um erro inesperado, volte e tente novamente, caso o problema persista entre em contato com o suporte."
					);
					setOpenToastErro(true);
					setLoading(false);
				}
				setLoading(false);
			});
	};

	useEffect(() => {
		if (!profile) return;
		setValues((current) => ({
			...current,
			usuario: profile?.usuario.usuario,
		}));
	}, [profile]);

	useEffect(() => {
		if (editando && profile?.token) {
			buscarFilialPorID();
		}
	}, [editando, profile?.token]);

	useEffect(() => {
		if (props.idAtual && profile?.token) {
			buscarFilialPorIDModal(props.idAtual);
		}
	}, [props.idAtual, profile?.token]);

	useEffect(() => {
		if (props.telaCadastro === true) {
			setTelaCadastro(true);
		}
	}, [props.telaCadastro]);

	const [semAutorizacao, setSemAutorizacao] = useState(false);

	useEffect(() => {
		if (profile?.token) {
			setSemAutorizacao(!hasRegra("Uso Comum"));
			buscarDependencias();
		}
	}, [profile?.token]);

	const [valuesSelect, setValuesSelect] = useState([]);

	const labelCidadeEstado = (data) => (
		<div style={{ display: "flex", alignItems: "center" }}>
			{data.cidade} - {data.estado}
			{valuesSelect.cidadeEstadoId === data && (
				<ClearIcon
					className="info-icon"
					onClick={(e) => {
						e.preventDefault();
						e.stopPropagation();
						clearCidade();
					}}
				/>
			)}
		</div>
	);

	const title = useMemo(() => {
		if (editando) return "Detalhes de Filial";
		if (telaCadastro) return "Cadastro de Filial";
		return "Filial";
	}, [editando, telaCadastro]);

	const clearCidade = () => {
		setValues((current) => ({
			...current,
			cidadeEstadoId: null,
		}));
		setValuesSelect((current) => ({ ...current, cidadeEstadoId: "" }));
		setValidator((current) => ({
			...current,
			cidadeEstadoId: "false",
		}));
	};

	const customStylesErro = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid red",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
			zIndex: 999,
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
		menuPortal: (provided) => ({
			...provided,
			zIndex: 1400,
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px",
		}),
	};

	const estiloCidadeEstado = {
		control: (provided) => ({
			...provided,
			minHeight: "30px",
			border: "none",
			borderRadius: "7px",
			border: "1px solid var(--Background-Input, #F2F2F2)",
			background: "var(--Background-Input, #F2F2F2)",
			"&:hover": {
				background: "#F0F6FF",
			},
		}),
		placeholder: (provided) => ({
			...provided,
			color: "var(--Placeholder-Color, #888)",
			fontSize: "12px",
		}),
		menu: (provided) => ({
			...provided,
			width: "max-content",
			minWidth: props.classeCss ? props.classeCss : "250px",
			zIndex: 999,
		}),
		menuPortal: (provided) => ({
			...provided,
			zIndex: 1400,
		}),
		singleValue: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
		option: (provided) => ({
			...provided,
			fontSize: "13px", // ajuste o tamanho da fonte conforme desejado
		}),
	};

	const handleChangeEmail = useCallback((e) => {
		setValues((current) => ({
			...current,
			email: e.target.value,
		}));
		setValidator((current) => ({
			...current,
			email: "true",
		}));
	}, []);

	const handleChangePhone = useCallback((e) => {
		if (e.target.value.length > 14) return;
		setValues((current) => ({
			...current,
			telefone: telefoneMask(e.target.value),
		}));
		setValidator((current) => ({
			...current,
			telefone: "true",
		}));
	}, []);

	const opcoesCidadeEstado = listaCidades.map((data) => ({
		value: data.idCidadeEstado,
		label: `${data.cidade} - ${data.estado}`,
		...data,
	}));

	useEffect(() => {
		setValidator({
			nome: "true",
			telefone: "true",
			email: "true",
			responsavel: "true",
			cidadeEstadoId: "true",
			complementoLocalizacao: "true",
		});
	}, [editando, telaCadastro]);

	if (semAutorizacao) {
		return <MotionSemAutorizacao />;
	}

	return (
		<Layout title={title} showNavbar={props.navbar}>
			<AnimatePresence mode="wait">
				{!telaCadastro ? (
					<MotionContainer key="FilialContainer">
						<div className="content-container">
							<Separator size="xl" />
							<TabelaV2
								setTelaCadastro={setTelaCadastro}
								setEditando={setEditando}
								classeSelecionado="idFilial"
								nomeClasse1="outer-wrapper-v2"
								nomeClasse2="table-v2-center"
								colunas={tabelaEmpresa.Filial}
								dados={dadosTabela}
								isLoading={loading}
							/>
						</div>
						<div className="footer-container">
							<div>
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Cadastrar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setTelaCadastro(true);
										setEditando(false);
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-editar"
									classText="button-texto-editar"
									titulo="Editar"
									icone="iconeEdit"
									cor="#CDCDCD"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setTelaCadastro(true);
											setEditando(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
								<CustomButtonV2
									classCss="custom-button-deletar"
									classText="button-texto-cadastrar"
									titulo="Deletar"
									icone="iconeDelete"
									cor="#DC2D2D"
									valor={values}
									onClick={() => {
										if (tabelaRedux.colunaSelecionada) {
											setOpen(true);
											setTextoSucesso("Deletado Com Sucesso");
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
							<div>
								<CustomButtonV2
									classCss="custom-button-user"
									classText="button-texto-user"
									titulo="Obter Usuário"
									cor="#FFFFFF"
									valor={values}
									onClick={() => {
										if (tabelaRedux.usuarioAlteracao) {
											setOpenUsuario(true);
										} else {
											setTextoErro("Selecione Uma Coluna");
											setOpenToastErro(true);
										}
									}}
								/>
							</div>
						</div>
					</MotionContainer>
				) : (
					<MotionContainer key="FilialCadastroContainer">
						<div className="content-container-scrollable">
							{!props.desabilitar && (
								<div className="texto-cadastro-container">
									{props.botaoFechar !== false && (
										<div style={{ width: 29, height: 29 }} />
									)}
									<div className="texto-cadastro">
										<p className="indicador-emb">{"Cadastro de Filial /"}</p>
										{editando ? (
											<p className="indicador-emb">{"Detalhes de Filial"}</p>
										) : (
											<p className="indicador-emb">{"Cadastro de Filial"}</p>
										)}
										<HeaderCadastro texto="" />
									</div>
									{props.botaoFechar !== false && (
										<div className="close-btn">
											<CloseIcon
												onClick={() => {
													setTabelaRedux({});
													setValues({});
													setValuesSelect({});
													setTelaCadastro(false);
													setEditando(false);
												}}
											/>
										</div>
									)}
								</div>
							)}
							<div className="flex-column">
								<div
									className="container-select-emb"
									style={{
										padding: "12px",
									}}
								>
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Nome:
												</p>
												<input
													type="text"
													id="nome"
													className="input-emb"
													style={{
														width: "250px",
														borderColor: !nomeValido ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															nome: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															nome: "true",
														}));
													}}
													placeholder="Ex: STS"
													value={values.nome}
													disabled={props.desabilitar}
												/>
												{!nomeValido && (
													<div className="error-input-text">Obrigatório</div>
												)}
											</div>
										</div>
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Telefone:
												</p>
												<input
													type="text"
													id="telefone"
													className="input-emb"
													style={{
														width: "250px",
														borderColor:
															validator.telefone === "false" ? "red" : "",
													}}
													onChange={handleChangePhone}
													placeholder="Ex: (99)99999-9999"
													value={telefoneMask(values.telefone)}
													disabled={props.desabilitar}
												/>
												{validator.telefone === "false" && (
													<div className="error-input-text">
														Telefone invalido.
													</div>
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div
											className={
												cidadeValido ? "coluna-emb" : "coluna-emb-erro"
											}
										>
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Cidade/UF:
												</p>
												<FormControl sx={{ width: 250 }}>
													<ReactSelect
														value={valuesSelect.cidadeEstadoId}
														isDisabled={props.desabilitar}
														options={opcoesCidadeEstado}
														formatOptionLabel={labelCidadeEstado}
														styles={
															cidadeValido
																? estiloCidadeEstado
																: customStylesErro
														}
														menuPortalTarget={document.body}
														placeholder="Selecione"
														noOptionsMessage={() => "Não há mais opções"}
														onChange={(selectedOption) => {
															if (selectedOption) {
																setValues((current) => ({
																	...current,
																	cidadeEstadoId: selectedOption.idCidadeEstado,
																}));
																setValuesSelect((current) => ({
																	...current,
																	cidadeEstadoId: selectedOption,
																}));
																setValidator((current) => ({
																	...current,
																	cidadeEstadoId: "true",
																}));
															}
														}}
													/>
												</FormControl>
												{!cidadeValido && (
													<div className="error-input-text">Obrigatório</div>
												)}
											</div>
										</div>
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Responsável:
												</p>
												<input
													type="text"
													id="responsavel"
													className="input-emb"
													style={{
														width: "250px",
														borderColor: !responsavelValido ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															responsavel: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															responsavel: "true",
														}));
													}}
													placeholder="Ex: Jõao"
													value={values.responsavel}
													disabled={props.desabilitar}
												/>
												{!responsavelValido && (
													<div className="error-input-text">Obrigatório</div>
												)}
											</div>
										</div>
									</div>
									<div className="rota-div-2">
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													E-mail:
												</p>
												<input
													type="email"
													id="email"
													className="input-emb"
													style={{
														width: "250px",
														border:
															validator.email === "false"
																? "1px solid red"
																: "",
													}}
													onChange={handleChangeEmail}
													placeholder="Ex: joao@gmail.com"
													value={values.email}
													disabled={props.desabilitar}
												/>
												{validator.email === "false" && (
													<p className="error-input-text">Email inválido</p>
												)}
											</div>
										</div>
										<div className="input-box-container">
											<div className="input-container">
												<p className="input-label-emb" htmlFor="descricao">
													Complemento Localização:
												</p>
												<input
													type="text"
													id="loc"
													className="input-emb"
													style={{
														width: "250px",
														borderColor: !locValido ? "red" : "",
													}}
													onChange={(e) => {
														setValues((current) => ({
															...current,
															complementoLocalizacao: e.target.value,
														}));
														setValidator((current) => ({
															...current,
															complementoLocalizacao: "true",
														}));
													}}
													placeholder="Ex: Toledo"
													value={values.complementoLocalizacao}
													disabled={props.desabilitar}
												/>
												{!locValido && (
													<div className="error-input-text">Obrigatório</div>
												)}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div className="footer-container">
							{editando ? (
								<CustomButtonV2
									classCss="custom-button-cadastrar"
									classText="button-texto-cadastrar"
									icone="iconeSave"
									titulo="Salvar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										editar();
									}}
								/>
							) : (
								<>
									{!props.desabilitar && (
										<CustomButtonV2
											classCss="custom-button-cadastrar"
											classText="button-texto-cadastrar"
											icone="iconeSave"
											titulo="Salvar"
											cor="#0946B8"
											valor={values}
											onClick={cadastrar}
										/>
									)}
								</>
							)}
							{!props.botaoVoltar && (
								<CustomButtonV2
									classCss="custom-button-cancelar"
									classText="button-texto-cancelar"
									titulo="Cancelar"
									cor="#0946B8"
									valor={values}
									onClick={() => {
										setValues({});
										setValuesSelect({});
										setTelaCadastro(false);
										setEditando(false);
									}}
								/>
							)}
						</div>
					</MotionContainer>
				)}
			</AnimatePresence>
			<div>
				<ModalConfirmacao
					titulo="Deletar"
					texto="Deseja Deletar?"
					tituloConfirmar="Confirmar"
					tituloCancelar="Cancelar"
					open={open}
					onClose={handleClose}
					onClick={deletarFilial}
				/>
				<ModalUsuario
					titulo="Usuário"
					tituloConfirmar="OK"
					open={openUsuario}
					onClose={handleCloseUsuario}
				/>
			</div>
			<div>
				<ToastSucesso
					texto={textoSucesso}
					open={openToastSucesso}
					onClose={handleCloseToastSucesso}
				/>
				<ToastErro
					texto={textoErro}
					open={openToastErro}
					onClose={handleCloseToastErro}
				/>
			</div>
		</Layout>
	);
}

export default Filial;
